var BillyDataHasMany = require('./billy-data-has-many')

module.exports = BillyDataHasMany.extend({
    model: Billy.ContactPerson
})
